<template>

    <v-dialog v-model="dialogVisible" max-width="500px" persistent>

        <v-card class="pa-4">
            <SignInForm v-on:is-authenticated="onAuthenticated" />
        </v-card>

    </v-dialog>
    
</template>

<!-- This is just a dialogue wrapper for the sign in form -->

<script lang="ts">
    import Vue from "vue";
    import Component from "vue-class-component";   
    import SignInForm from "@/vue/components/SignInForm.vue";

    @Component({
        components: { SignInForm }
    })
    export default class SignInDialogue extends Vue {

        dialogVisible: boolean = false;

        show() {           
            this.dialogVisible = true;
        }

        hide() {
            this.dialogVisible = false;
        }

        onAuthenticated() {
            console.log("...SignInDialogue component - onAuthenticated");
            this.hide();
            // just bubble up after hiding self
            this.$emit("is-authenticated");
        }
    }
</script>